export type DashboardSecurityLink = {
  id: string;
  label: string;
  url: string;
};

const DEFAULT_SECURITY_LINKS: readonly DashboardSecurityLink[] = [
  {
    id: 'entra',
    label: 'Entra Admin Center',
    url: 'https://entra.microsoft.com',
  },
  {
    id: 'm365',
    label: 'Microsoft 365 Admin',
    url: 'https://admin.microsoft.com',
  },
  {
    id: 'security',
    label: 'Microsoft Security',
    url: 'https://security.microsoft.com',
  },
];

function envUrl(key: keyof ImportMetaEnv): string | undefined {
  const value: unknown = import.meta.env[key];
  if (typeof value !== 'string') {
    return undefined;
  }
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : undefined;
}

/** External identity/security portals — links only, no live Microsoft APIs. */
export function dashboardSecurityLinks(): DashboardSecurityLink[] {
  return DEFAULT_SECURITY_LINKS.map((link) => {
    if (link.id === 'entra') {
      return { ...link, url: envUrl('VITE_ENTRA_ADMIN_URL') ?? link.url };
    }
    if (link.id === 'm365') {
      return { ...link, url: envUrl('VITE_M365_ADMIN_URL') ?? link.url };
    }
    if (link.id === 'security') {
      return { ...link, url: envUrl('VITE_MS_SECURITY_URL') ?? link.url };
    }
    return link;
  });
}
